/* eslint-disable  */
// import { getCoreBlocks } from './core.js';

const gap = '<sep gap="36"/>';


const cdg1_event_blocks = function () {
  return `
  <category
    name="Event"
    id="cdg1_event"
    colour="#FFBF00"
    secondaryColour="#E6AC00">
      <block type="cdg1_event_whenenemyentersattackrange">
      </block>
      <block type="cdg1_event_whennoenemiesareinattackrange">
      </block>
      <block type="cdg1_event_whenythemouserightclicks">
      </block>
      <block type="cdg1_event_whenitemdrops">
      </block>
      <block type="cdg1_event_whencobotisholding">
      </block>

  </category>
  `
}
const cdg1_motion_blocks = function () {
  return `
  <category
    name="Motion"
    id="cdg1_motion"
    colour="#F65DCE"
    secondaryColour="#E20F9C">
      <block type="cdg1_motion_movetoposition">
      </block>
      <block type="cdg1_motion_follow">
      </block>
  </category>
  `
}
const cdg1_action_blocks = function () {
  return `
  <category
    name="Action"
    id="cdg1_action"
    colour="#0fBD8C"
    secondaryColour="#0DA57A">
      <block type="cdg1_action_attack">
      </block>
  </category>
  `
}
const makeCDG1ToolboxXML = () => {
  const xmlOpen = '<xml style="display: none">';
  const xmlClose = "</xml>";
  // const coreCategories = getCoreBlocks();
  return [
    xmlOpen,
    gap,
    cdg1_event_blocks(),
    gap,
    cdg1_motion_blocks(),
    gap,
    cdg1_action_blocks(),
    xmlClose
  ].join("\n");
}

export { makeCDG1ToolboxXML };